import { RecommendationType } from '../spaces/RecommendationSpace/RecommendationTypeDropdown';
import { AppState } from '../state/AppState';

export function selectRecommendationType(state: AppState): RecommendationType {
  return state.contentExplorer.recommendationType;
}
